import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Link, useParams } from "react-router-dom";
import { Footer, Navbar } from "../components";
import axios from "axios";
import configData from "../config.json";
import { Button, div } from "bootstrap";
import dateFormat,{masks} from "dateformat";

const FaqPage=()=>{
    const { id } = useParams();
    const [csCenter,setcsCenter]=useState([]);
   

    useEffect(() => {
        const getcsCenter = async () => {
        const response=await axios.get(configData.SERVER_URL+'/faq')
          setcsCenter(response.data);
        };
        getcsCenter();
    }, []);

    return(
        <>
        <Navbar/>
        <div className="container my-3 py-3">
        <h1 className="text-center">FAQ Details</h1>
            <hr/>
          {
            csCenter && csCenter.length>0 && csCenter.map((i)=> 
            <div className="card text-justify">  
                <div className="card-header"></div>           
                    <div className="card-body">
                    <p>{i.Content}</p>
                    <hr/>
                    <p style={{color:'green'}}>{i.repContent}</p>
                </div>
            </div>
            )
          }
        </div>
        <Footer/>
        </>
    )  
}

export default FaqPage;